import { Component, OnInit } from '@angular/core';
import { DashboardData } from '../model/dashboard.model';
import { ApiService } from '../services/api.service';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  dashboardDetails: DashboardData = null;
  constructor(private apiService: ApiService) {
  }

  ngOnInit(): void {
    this.apiService.getDasboradDetails().subscribe(data => {
      this.dashboardDetails = data;
    });
  }

}
